
import React from 'react';
import { Button } from "@/components/ui/button";
import { ExternalLink } from 'lucide-react';

const AboutHero = () => {
  return (
    <section className="bg-gradient-to-r from-piano-black to-gray-900 text-white py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          <div className="lg:col-span-3">
            <h1 className="text-4xl md:text-5xl font-serif font-bold mb-6">
              Om Oscar Gilbert
            </h1>
            <p className="text-xl text-gray-300 mb-8">
              Konservatorieuddannet pianist med passion for at undervise og inspirere pianister på alle niveauer.
            </p>
            <Button asChild className="bg-piano-gold hover:bg-piano-gold/90 text-white">
              <a href="https://oscargilbert.dk" target="_blank" rel="noopener noreferrer" className="flex items-center">
                <span>Se min professionelle pianist-side</span>
                <ExternalLink className="ml-2 h-4 w-4" />
              </a>
            </Button>
          </div>
          <div className="lg:col-span-2">
            <div className="relative">
              <div className="absolute -inset-1 bg-gradient-to-r from-piano-gold to-amber-400 rounded-lg blur opacity-30"></div>
              <div className="relative bg-gray-800 p-3 rounded-lg shadow-xl">
                <div className="aspect-square bg-gray-700 rounded-md overflow-hidden">
                  <img 
                    src="/lovable-uploads/5d002198-ecfc-4ca4-9b1d-57761c26abb4.png" 
                    alt="Oscar Gilbert Portræt" 
                    className="w-full h-full object-cover"
                    width="400"
                    height="400"
                    loading="eager"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default React.memo(AboutHero);
